import { render, staticRenderFns } from "./ShareVehicle.vue?vue&type=template&id=23a91fbf&"
import script from "./ShareVehicle.vue?vue&type=script&lang=js&"
export * from "./ShareVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports